import "./styles.scss"

const Footer = () => {
  return (
    <footer>
      <div className="container-fluid">
        <div className="d-flex flex-wrap justify-content-between align-items-center">
          <div className="col-md-4 d-flex align-items-center">
            
            <span className="mb-3s mb-md-0">
              © 2025 CCI USA. All rights reserved
            </span>
          </div>

          <ul className="nav col-md-4 justify-content-end list-unstyled d-flex gap-4">
            <li className="">
              <a className="text-body-twitter" href="https://x.com/cci_america">
                <i className="fa-brands fa-twitter"></i>
              </a>
            </li>
            <li className="">
              <a className="text-body-instagram" href="https://www.instagram.com/cci_america/">
                <i className="fa-brands fa-instagram"></i>
              </a>
            </li>
            <li className="">
              <a className="text-body-youtube" href="https://www.youtube.com/@CelebrationChurchGlobal">
                <i className="fa-brands fa-youtube"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
